import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import React from 'react';

function FlixmediaRetailerIframe({
  mpn = null,
  ean = null,
  distributor = null,
  language = null,
  fallbackLanguage = null,
}) {

  return (
    <Helmet>
      <script
        type="text/javascript"
        src="//media.flixfacts.com/js/loader.js"
        data-flix-brand=""
        data-flix-mpn={mpn}
        data-flix-ean={ean}
        data-flix-inpage="flix-inpage"
        data-flix-button-image=""
        data-flix-price=""
        async
        data-flix-distributor={distributor}
        data-flix-language={language}
        data-flix-fallback-language={fallbackLanguage}
      >
      </script>
    </Helmet>
  );
}

export default inject('orderStore')(observer(FlixmediaRetailerIframe));
